import { apiLogIn, apiForn, apiCat } from "./api";
import { jwtDecode } from "jwt-decode";

export const TOKEN_KEY = "token_key_forn";
export const TOKEN_KEY_CAT = "token_key_catalogo";
export const DADOS_LOGIN = "dados_login_forn";
export const DADOS_LOGIN_CAT = "dados_login_catalogo";
export const TOKEN_REFRESH = "token_refresh_forn";
export const DADOS = "dados_forn";
export const CLIENTE_KEY = "cliente_key_forn";
export const CLIENTE_DOC = "cliente_cod_forn";
export const CLIENTE_PROF = "cliente_prof_forn";
export const PARCEIRO = "parceiro";

export const isAuthenticated = () => {
  if (getToken() !== null) {
    const decoded = jwtDecode(getToken(), { complete: true });
    if (decoded !== null) {
      var dataSeg = new Date((decoded.exp * 1000) - 150000);
      var dataExpirado = dataSeg.getTime();

      var dataSeg2 = new Date();
      var dataAgora = dataSeg2.getTime();
      if (getRefresh() == "true") {
        if (dataAgora > dataExpirado) {
          var dadosToken = getDados();
          if (dadosToken !== null) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      } else {
        return true;
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
};

export const getRefresh = () => localStorage.getItem(TOKEN_REFRESH);
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const set_Login = token => {
  localStorage.setItem(TOKEN_REFRESH, "true");
  localStorage.setItem(TOKEN_KEY, token);
};

export const getDados = () => JSON.parse(localStorage.getItem(DADOS_LOGIN));
export const set_Dados = dados => {
  localStorage.setItem(DADOS_LOGIN, JSON.stringify(dados));
};

export const getTokenCAT = () => localStorage.getItem(TOKEN_KEY_CAT);
export const set_LoginCAT = token => {
  localStorage.setItem(TOKEN_KEY_CAT, token);
};

export const getrefreshCat = () => localStorage.getItem(DADOS_LOGIN_CAT);
export const set_refreshCAT = dados => {
  localStorage.setItem(DADOS_LOGIN_CAT, dados);
};

export const DeleteTokenCat = () => {
  localStorage.removeItem(DADOS_LOGIN_CAT);
  localStorage.removeItem(TOKEN_KEY_CAT);
};

export const getCliente = () => localStorage.getItem(CLIENTE_KEY);
export const set_Cliente = idCliente => {
  localStorage.setItem(CLIENTE_KEY, idCliente);
};

export const getDocCliente = () => localStorage.getItem(CLIENTE_DOC);
export const set_DocCliente = DocCliente => {
  localStorage.setItem(CLIENTE_DOC, DocCliente);
};

export const getProfCliente = () => localStorage.getItem(CLIENTE_PROF);
export const set_ProfCliente = ProfCliente => {
  localStorage.setItem(CLIENTE_PROF, ProfCliente);
};

export const getParceiro = () => localStorage.getItem(PARCEIRO);
export const set_Parceiro = idParceiro => {
  localStorage.setItem(PARCEIRO, idParceiro);
};

export const logout = () => {
  //alert('SAINDO auth');
  window.localStorage.clear(); 
  window.location.reload();
};

export const autenticaLogon = dados => {
  localStorage.setItem(TOKEN_REFRESH, "true");
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Access-Control-Allow-Origin': "*",
      'Cache-Control': 'no-cache'
    }
  };

  dados = {
    ...dados,
    "Grant_Type": "password"
  }
  return apiLogIn.post('Account/Logon', JSON.stringify(dados), defaultOptions);
};

export const autenticaLogonCat = dados => {
  localStorage.setItem(TOKEN_REFRESH, "true");
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Access-Control-Allow-Origin': "*",
      'Cache-Control': 'no-cache'
    }
  };
  dados = {
    ...dados,
    "Grant_Type": "password",
    "scope": "apiomnion apicatalogo offline_access"
  }
  return apiLogIn.post('Account/Logon', JSON.stringify(dados), defaultOptions);
};

export const RefresToken = async dados => {
  const decoded = jwtDecode(getToken(), { complete: true });
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    }
  };
  dados = {
    ...dados,
    "Grant_Type": "refresh_token"
  }
  var retorno = await apiLogIn.post('Account/Refresh', JSON.stringify(dados), defaultOptions);
  //console.log(retorno);
  await set_Login(retorno.data.result.access_token);

  var decoded2 = jwtDecode(retorno.data.result.access_token, { complete: true });
  if (decoded2 != "" && decoded2 != null && decoded2 != undefined) {
    var Name = decoded2.payload.FullName.split(" ");
    await set_Cliente(Name[0]);

    retorno.data.result.FullName = decoded2.payload.FullName;

    await set_Dados(retorno.data.result);
  }

  await set_Dados(retorno.data.result);
  localStorage.setItem(TOKEN_REFRESH, "true");
  if (retorno.data.sucesso !== true) {
    window.location = '/';
  } else {
    if (decoded !== null) {
      var dataSeg = new Date((decoded.exp * 1000) - 100000);
      var dataExpirado = dataSeg.getTime();

      var dataSeg2 = new Date();
      var dataAgora = dataSeg2.getTime();
      if (dataAgora > dataExpirado && getRefresh()) {
        window.location = window.location.href;
      }
    }
  }
};

export const PostFormApi = (URL, dados, defaultOptions = null) => {
  if (defaultOptions != null) {
    defaultOptions = {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'Access-Control-Allow-Origin': "*",
        'Cache-Control': 'no-cache'
      }
    };
  }
  return apiForn.post(URL, dados, defaultOptions);
};

export const PutFormApi = (URL, dados, defaultOptions = null) => {
  if (defaultOptions != null) {
    defaultOptions = {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'Access-Control-Allow-Origin': "*",
        'Cache-Control': 'no-cache'
      }
    };
  }
  return apiForn.put(URL, dados, defaultOptions);
};

export const PostApi = (URL, dados) => {
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Access-Control-Allow-Origin': "*",
      'Cache-Control': 'no-cache'
    }
  };
  return apiForn.post(URL, JSON.stringify(dados), defaultOptions);
};

export const PostApiCat = (URL, dados) => {
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Access-Control-Allow-Origin': "*",
      'Cache-Control': 'no-cache'
    }
  };
  return apiCat.post(URL, JSON.stringify(dados), defaultOptions);
};

export const PostApi2 = (URL, dados) => {
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Access-Control-Allow-Origin': "*",
      'Cache-Control': 'no-cache'
    }
  };
  apiForn.post(URL, JSON.stringify(dados), defaultOptions);
};

export const GetApi = (URL) => {
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Access-Control-Allow-Origin': "*",
      'Cache-Control': 'no-cache'
    }
  };
  return apiForn.get(URL, defaultOptions);
};

export const PostApiOut = (URL, dados, token) => {
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Access-Control-Allow-Origin': "*",
      'Cache-Control': 'no-cache',
      // 'Authorization': `bearer ${token}`
    }
  };
  return apiLogIn.post(URL, JSON.stringify(dados), defaultOptions);
};

export const PutApi = (URL, dados) => {
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Access-Control-Allow-Origin': "*",
      'Cache-Control': 'no-cache'
    }
  };
  return apiForn.put(URL, JSON.stringify(dados), defaultOptions);
};

export const PostApiOut2 = (URL, dados) => {
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Access-Control-Allow-Origin': "*",
      'Cache-Control': 'no-cache'
    }
  };
  return apiLogIn.post(URL, JSON.stringify(dados), defaultOptions);
};

export const GetApiOut = (URL) => {
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Access-Control-Allow-Origin': "*",
      'Cache-Control': 'no-cache'
    }
  };
  return apiLogIn.get(URL, defaultOptions);
};
